// extracted by mini-css-extract-plugin
export default {"SubscribeButton":"n3kY6rXdxAlE2fl92Pi7","LocationDetail_nav":"WzqLOIJujsQd1JfPnHq9","LocationDetail_events":"dinJlVK6r6oAN2HzyoKE"};